import styled from "styled-components";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-start;
	gap: 1rem;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 1rem;

	> ${AreaButtons} {
		grid-column: 1 / -1;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-template-columns: repeat(2, 1fr);

		> ${AreaButtons} {
			grid-column: 1 / -1;
		}
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		display: flex;
		flex-direction: column;

		> ${AreaButtons} {
			flex-direction: column;

			> button {
				width: 100%;
				max-width: 100%;
			}
		}
	}
`;

export const AreaCheckbox = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 50%);
	align-items: center;
	overflow: hidden;

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		grid-template-columns: 100%;
		gap: 1rem;

		.MuiCheckbox-root {
			padding-top: 0;
			padding-bottom: 0;
		}
	}
`;

export const FavoriteSearchLabel = styled(FormControlLabel)`
	&& .MuiFormControlLabel-label {
		white-space: nowrap;
	}
`;

export const PredefinedSearchLabel = styled(FormControlLabel)`
	&& .MuiFormControlLabel-label {
		white-space: nowrap;
	}
`;

export const AutoCompleteWrapper = styled.div`
	position: relative;
	height: 40px;
	width: 100%;
	min-width: 0;
	z-index: 2;

	&& .MuiAutocomplete-root {
		width: 100%;
		min-width: 0;
	}

	&& .MuiAutocomplete-inputRoot {
		width: 100%;
		min-width: 0;
	}

	&& .MuiAutocomplete-tag {
		max-width: 80% !important;
	}

	&& .MuiAutocomplete-tag .MuiChip-label {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	@media (max-width: 768px) {
		&& .MuiAutocomplete-tag {
			max-width: 70% !important;
		}
	}
`;

export const InputWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	min-width: 0;
`;
